var viewport;
export default (function () {
  if (!viewport) {
    viewport = document.compatMode === 'CSS1Compat' ? document.documentElement : document.scrollingElement || document.documentElement;
  }

  return viewport;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/scroll-into-view-if-needed/es/viewport.js
// module id = 269
// module chunks = 0